import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
export const pulse = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

pulse.definition = {
    methods: ["get","head"],
    url: '/dashboard/pulse',
} satisfies RouteDefinition<["get","head"]>

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
pulse.url = (options?: RouteQueryOptions) => {
    return pulse.definition.url + queryParams(options)
}

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
pulse.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
pulse.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pulse.url(options),
    method: 'head',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
const pulseForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pulse.url(options),
    method: 'get',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
pulseForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pulse.url(options),
    method: 'get',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/dashboard/pulse'
*/
pulseForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pulse.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pulse.form = pulseForm

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\HomeController::__invoke
* @see app/Http/Controllers/Public/HomeController.php:20
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
export const story = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: story.url(options),
    method: 'get',
})

story.definition = {
    methods: ["get","head"],
    url: '/pribeh',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
story.url = (options?: RouteQueryOptions) => {
    return story.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
story.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: story.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
story.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: story.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
const storyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: story.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
storyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: story.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\StoryController::__invoke
* @see app/Http/Controllers/Public/StoryController.php:15
* @route '/pribeh'
*/
storyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: story.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

story.form = storyForm

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
export const faq = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

faq.definition = {
    methods: ["get","head"],
    url: '/faq',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
faq.url = (options?: RouteQueryOptions) => {
    return faq.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
faq.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
faq.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: faq.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
const faqForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
faqForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\FaqController::__invoke
* @see app/Http/Controllers/Public/FaqController.php:16
* @route '/faq'
*/
faqForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

faq.form = faqForm

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/pravidla',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
const termsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
termsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::terms
* @see app/Http/Controllers/Public/LegalController.php:25
* @route '/pravidla'
*/
termsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: terms.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

terms.form = termsForm

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/soukromi',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
const privacyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
privacyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::privacy
* @see app/Http/Controllers/Public/LegalController.php:37
* @route '/soukromi'
*/
privacyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: privacy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

privacy.form = privacyForm

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
export const cookies = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

cookies.definition = {
    methods: ["get","head"],
    url: '/cookies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
cookies.url = (options?: RouteQueryOptions) => {
    return cookies.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
cookies.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
cookies.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookies.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
const cookiesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
cookiesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::cookies
* @see app/Http/Controllers/Public/LegalController.php:49
* @route '/cookies'
*/
cookiesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cookies.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cookies.form = cookiesForm

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
export const reportContent = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reportContent.url(options),
    method: 'get',
})

reportContent.definition = {
    methods: ["get","head"],
    url: '/nahlasit-obsah',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
reportContent.url = (options?: RouteQueryOptions) => {
    return reportContent.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
reportContent.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reportContent.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
reportContent.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reportContent.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
const reportContentForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reportContent.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
reportContentForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reportContent.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\LegalController::reportContent
* @see app/Http/Controllers/Public/LegalController.php:61
* @route '/nahlasit-obsah'
*/
reportContentForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reportContent.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reportContent.form = reportContentForm

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/hledat',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
const searchForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
searchForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\SearchController::search
* @see app/Http/Controllers/Public/SearchController.php:47
* @route '/hledat'
*/
searchForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

search.form = searchForm

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm
